module.exports = __webpack_public_path__ + "static/media/stripe-onboarding_1.d7b4c6e8.png";